module.exports = __webpack_public_path__ + "img/alarm_8.svg";